import gql from 'graphql-tag'
import { noteAttrsForListsFragment } from '../notes'
import { threadAttrsWithCommentsFragment } from '../threads'

export const noteActivityAttrsFragment = gql`
  fragment noteActivityAttrs on NoteActivity {
    id
    __typename
    createdAt
    noteId
    userIds
    type
    metadata
    note {
      ...noteAttrsForLists
    }
  }
  ${noteAttrsForListsFragment}
`

export const fetchNoteActivities = gql`
  query fetchNoteActivities($noteId: ID!) {
    showNote(noteId: $noteId) {
      id
      __typename
      commenterIds
      mentionedIds
      writerIds
      activities {
        ...noteActivityAttrs
      }
    }
  }
  ${noteActivityAttrsFragment}
`

export const fetchNoteActivitiesWithContent = gql`
  query fetchNoteActivities($noteId: ID!) {
    showNote(noteId: $noteId) {
      id
      __typename
      contentAsText
      commenterIds
      mentionedIds
      writerIds
      activities {
        ...noteActivityAttrs
      }
    }
  }
  ${noteActivityAttrsFragment}
`

export const fetchAllNoteActivities = gql`
  query listNoteActivities($pagination: PaginationInput) {
    listNoteActivities(pagination: $pagination) {
      totalCount
      edges {
        cursor
        node {
          ...noteActivityAttrs
          thread {
            ...threadAttrsWithComments
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
  ${noteActivityAttrsFragment}
  ${threadAttrsWithCommentsFragment}
`
